// ä¸è¬ç¨äº ecp-flex-tcb,ecp-flex-lcr çå­ç»ä»¶

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-module-title',
  templateUrl: './module-title.component.html',
  styleUrls: ['./module-title.component.css']
})
export class ModuleTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
